import { ScrollArea } from '@mantine/core';
import { cn } from '@xver/utils/classname';
import { NavigationList } from '../../Molecules';
import { NavigationSideBarProps } from './NavigationSideBar.types';

export default function NavigationSideBar({
    lists,
    className,
    disableTooltip,
}: NavigationSideBarProps) {
    return (
        <ScrollArea className={cn('w-full h-full', className)} scrollbars="y" offsetScrollbars>
            <div className="w-full flex flex-col justify-start items-start gap-4">
                {lists.map((list) => (
                    <NavigationList key={list.name} {...list} disableTooltip={disableTooltip} />
                ))}
            </div>
        </ScrollArea>
    );
}
